import { Track } from '../types';

/**
 * Shared utilities for working with audio tracks.
 */

/**
 * Adjusts track audio paths for a non-main language.
 *
 * Additional languages exist in separate folders, so this function
 * inserts the language code into the path before the filename.
 *
 * @param tracks - Array of tracks to adjust
 * @param language - Target language code
 * @returns Adjusted tracks with language-specific paths
 *
 * @example
 * Input: audio.src = "content/audio/track1.mp3", language = "es"
 * Output: audio.src = "content/audio/es/track1.mp3"
 */
export const getTracksForLanguage = (tracks: Track[], language: string): Track[] => {
  return tracks.map((track) => {
    // Insert language folder before the filename in the src path
    const srcParts = track.audio.src.split('/');
    srcParts.splice(srcParts.length - 1, 0, language);

    // Insert language folder before the filename in the url path
    const urlParts = track.audio.url.split('/');
    urlParts.splice(urlParts.length - 1, 0, language);

    return {
      text: track.text,
      audio: {
        ...track.audio,
        src: srcParts.join('/'),
        url: urlParts.join('/'),
      },
    };
  });
};
